import { NoSymbolIcon } from "@heroicons/react/24/outline";
import classNames from "classnames";
import Text from "@/components/base/text";
import OptionButton from "./option-button";
import FeatureList from "./feature-list";

const ShippingOption = ({
  subtext,
  features,
  premiumFeatures = null,
  disabled = false,
  disabledText = "",
  ...props
}) => {
  return (
    <div className="relative">
      <OptionButton disabled={disabled} {...props} />
      <Text className="mt-2 italic" color="primary" align="center" size="vsm">
        {subtext}
      </Text>
      <div className="flex gap-x-2 sm:gap-x-0.5 lg:gap-x-2 justify-center">
        <FeatureList
          className={classNames("mt-3", premiumFeatures && "basis-1/2")}
          features={features}
        />
        {premiumFeatures && (
          <FeatureList
            className="mt-3 basis-1/2"
            features={premiumFeatures}
            isPremium
          />
        )}
      </div>
      {disabled && (
        <div className="absolute inset-0 flex flex-col justify-center items-center p-10 z-10 backdrop-blur-sm bg-white/30">
          <NoSymbolIcon className="h-6 w-6" aria-hidden="true" />
          <Text className="mt-2" size="vsm" weight="bold" align="center">
            {disabledText}
          </Text>
        </div>
      )}
    </div>
  );
};

export default ShippingOption;
